import { eventQBus } from "../../../exports/event-q-bus";
import { getPagecluster } from "../../../exports/misc";
import { toggle } from "../../../exports/toggle";
import { loggerScope } from "../parser/utils.js";

const pdpPageClusterIds = ["Artikeldetailseite"];
const pdpReloadEventName = "ft5.components.reload";

const log = loggerScope.scope("init");

export function isPdpWorkaroundEnabled(): boolean {
  return !!(
    toggle.get("gr_tracking_enable_pdp_workaround", true) &&
    pdpPageClusterIds.includes(getPagecluster() ?? "")
  );
}

export function initPdpWorkaround(initCallback: () => void): void {
  const pdpReloadCompleteCallback = (): void => {
    initCallback();
    eventQBus.off(pdpReloadEventName, pdpReloadCompleteCallback);
  };

  log.info("PDP page detected, waiting for reload event to initialize data tracker");
  eventQBus.on(pdpReloadEventName, pdpReloadCompleteCallback);
}
